import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION, MutualFundAmountSelected } from "./types";
import { continueButtonAction, selectTheValueSelected } from "./action";
export const template = {
    layout: {
        id: ROUTE.ASK_MUTUAL_FUND,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "containerStack", type: WIDGET.STACK },
            { id: "continueStack", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM }
        ],
    },
    datastore: {
        questionText: {
            label: 'What is the amount of your savings in mutual funds?',
            fontWeight: '700',
            fontSize: FontSizeTokens.XL,
            lineHeight: 28,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins
        },
        descriptionText: {
            label: 'We require this to improve your experience',
            fontWeight: '400',
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Inter,
            textAlign: TextAlignTokens.left
        },
        containerStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "questionText", type: WIDGET.TEXT },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "descriptionText", type: WIDGET.TEXT },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "noMutualFundStack", type: WIDGET.STACK },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "tenToFiftyStack", type: WIDGET.STACK },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "fiftyToTwoLakhStack", type: WIDGET.STACK },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "twoToTenLakhStack", type: WIDGET.STACK },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "moreThanTenLakhStack", type: WIDGET.STACK },
            ]
        },
        spaceXXXXXL: {
            size: SizeTypeTokens.XXXXXL
        },
        tenToFiftyStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Grey_Chalk,
            },
            padding: {
                all: SizeTypeTokens.SIZE14,
                left: SizeTypeTokens.XXXL,
                right: SizeTypeTokens.XXXXXXL
            },
            action: {
                type: ACTION.POST_SELECTED_VALUE,
                payload: {
                    value: MutualFundAmountSelected.TEN_TO_FIFTY_K
                },
            },
            widgetItems: [
                { id: "tenToFiftyText", type: WIDGET.TEXT },
                { id: "tentoFiftyImage", type: WIDGET.ICON }
            ]
        },
        fiftyToTwoLakhStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Grey_Chalk,
            },
            padding: {
                all: SizeTypeTokens.SIZE14
            },
            action: {
                type: ACTION.POST_SELECTED_VALUE,
                payload: {
                    value: MutualFundAmountSelected.FIFTY_TO_TWO_LAKH
                },
            },
            widgetItems: [
                { id: "fiftyToTwoLakhText", type: WIDGET.TEXT },
                { id: "fiftyToTwoLakhImage", type: WIDGET.ICON }
            ]
        },
        twoToTenLakhStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Grey_Chalk,
            },
            padding: {
                all: SizeTypeTokens.SIZE14
            },
            action: {
                type: ACTION.POST_SELECTED_VALUE,
                payload: {
                    value: MutualFundAmountSelected.TWO_TO_TEN_LAKH
                },
            },
            widgetItems: [
                { id: "twoToTenLakhText", type: WIDGET.TEXT },
                { id: "twoToTenLakhImage", type: WIDGET.ICON }
            ]
        },
        moreThanTenLakhStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Grey_Chalk,
            },
            action: {
                type: ACTION.POST_SELECTED_VALUE,
                payload: {
                    value: MutualFundAmountSelected.MORE_THAN_TEN_LAKH
                },
            },
            padding: {
                all: SizeTypeTokens.SIZE14
            },
            widgetItems: [
                { id: "moreThanTenLakhText", type: WIDGET.TEXT },
                { id: "moreThanTenLakhImage", type: WIDGET.ICON }
            ]
        },
        noMutualFundStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Grey_Chalk,
            },
            padding: {
                all: SizeTypeTokens.SIZE14
            },
            action: {
                type: ACTION.POST_SELECTED_VALUE,
                payload: {
                    value: MutualFundAmountSelected.NO_MUTUAL_FUND
                },
            },
            widgetItems: [
                { id: "noMutualFundText", type: WIDGET.TEXT },
                { id: "noMutualFundsImage", type: WIDGET.ICON }
            ]
        },
        tentoFiftyImage: {
            name: IconTokens.TenToFiftyThousand,
            size: IconSizeTokens.XXXXL
        },
        fiftyToTwoLakhImage: {
            name: IconTokens.FiftyToTwoLakh,
            size: IconSizeTokens.XXXXL
        },
        twoToTenLakhImage: {
            name: IconTokens.TwoToTenLakh,
            size: IconSizeTokens.XXXXL
        },
        moreThanTenLakhImage: {
            name: IconTokens.MoreThanTenLakh,
            size: IconSizeTokens.XXXXL
        },
        noMutualFundsImage: {
            name: IconTokens.NoMutualFund,
            size: IconSizeTokens.XXXXL
        },
        tenToFiftyText: {
            label: '₹10K - ₹50K',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Night
        },
        fiftyToTwoLakhText: {
            label: '₹50K - ₹2L',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Night
        },
        twoToTenLakhText: {
            label: '₹2L - ₹10L',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Night
        },
        moreThanTenLakhText: {
            label: 'More than ₹10L',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Night
        },
        noMutualFundText: {
            label: 'No mutual fund savings',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Night
        },
        noText: {
            label: 'No',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Poppins,
            color: ColorTokens.Grey_Night
        },
        yesImage: {
            uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/yes_default.png',
            size: ImageSizeTokens.SM,
        },
        noImage: {
            uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/no_default.png',
            size: ImageSizeTokens.SM,
        },
        spaceLG: {
            size: SizeTypeTokens.LG
        },
        spaceXL: {
            size: SizeTypeTokens.XL
        },
        spaceXXXL: {
            size: SizeTypeTokens.XXXL
        },
        spaceXXL: {
            size: SizeTypeTokens.XXL
        },
        continueStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            widgetItems: [
                { id: "continueButton", type: WIDGET.BUTTON }
            ]
        },
        continueButton: {
            label: "Continue",
            fontFamily: FontFamilyTokens.Inter,
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.LargeOutline,
            action: {
                type: ACTION.CONTINUE_BUTTON_ACTION,
                routeId: ROUTE.ASK_MUTUAL_FUND
            }
        },
    },
};
export const askMutualFundMF = {
    onLoad: async () => {
        return Promise.resolve(template);
    },
    actions: {
        [ACTION.POST_SELECTED_VALUE]: selectTheValueSelected,
        [ACTION.CONTINUE_BUTTON_ACTION]: continueButtonAction
    },
};
